// extracted by css-extract-rspack-plugin
export default {"panel":"Panel_panel__A1jhH","restrictedWidth":"Panel_restrictedWidth__5SP85"};